var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dabutton",class:['dabutton1-' + _vm.device],style:({background:_vm.background,color:_vm.color,border:'1px solid '+_vm.borderColor}),on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }